"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageMap = void 0;
var Pages_1 = require("@/rendering/common/Pages");
var Search_1 = require("@/pages/search/components/Search");
var RootSearchSaga_1 = require("@/pages/search/sagas/RootSearchSaga");
var RootSearchReducer_1 = require("@/pages/search/reducers/RootSearchReducer");
var AboutUs_1 = require("@/pages/aboutUs/components/AboutUs");
var AboutUsSaga_1 = require("@/pages/aboutUs/sagas/AboutUsSaga");
var RootAboutUsReducer_1 = require("@/pages/aboutUs/reducers/RootAboutUsReducer");
var AccountInfo_1 = require("@/pages/accountInfo/components/AccountInfo");
var RootAccountInfoReducer_1 = require("@/pages/accountInfo/reducers/RootAccountInfoReducer");
var RootAccountInfoSaga_1 = require("@/pages/accountInfo/sagas/RootAccountInfoSaga");
var AccountLogin_1 = require("@/pages/accountLogin/components/AccountLogin");
var RootAccountLoginReducer_1 = require("@/pages/accountLogin/reducers/RootAccountLoginReducer");
var AccountLoginSaga_1 = require("@/pages/accountLogin/sagas/AccountLoginSaga");
var AgentProfile_1 = require("@/pages/agentProfile/components/AgentProfile");
var RootAgentProfileReducer_1 = require("@/pages/agentProfile/reducers/RootAgentProfileReducer");
var RootAgentProfileSaga_1 = require("@/pages/agentProfile/sagas/RootAgentProfileSaga");
var Alert_1 = require("@/pages/alert/components/Alert");
var RootAlertReducer_1 = require("@/pages/alert/reducers/RootAlertReducer");
var RootAlertSaga_1 = require("@/pages/alert/sagas/RootAlertSaga");
var ConfirmEmailRegister_1 = require("@/pages/confirmEmailRegister/components/ConfirmEmailRegister");
var Home_1 = require("@/pages/home/components/Home");
var RootConfirmEmailRegisterReducer_1 = require("@/pages/confirmEmailRegister/reducers/RootConfirmEmailRegisterReducer");
var RootConfirmEmailRegisterSaga_1 = require("@/pages/confirmEmailRegister/sagas/RootConfirmEmailRegisterSaga");
var RootContactAgentReducer_1 = require("@/pages/contactAgent/reducers/RootContactAgentReducer");
var ContactAgentPageSaga_1 = require("@/pages/contactAgent/sagas/ContactAgentPageSaga");
var Development_1 = require("@/pages/development/Development");
var RootDevelopmentReducer_1 = require("@/pages/development/reducers/RootDevelopmentReducer");
var DevelopmentSaga_1 = require("@/pages/development/sagas/DevelopmentSaga");
var Developments_1 = require("@/pages/developments/Developments");
var RootDevelopmentsReducer_1 = require("@/pages/developments/reducers/RootDevelopmentsReducer");
var DevelopmentsSaga_1 = require("@/pages/developments/sagas/DevelopmentsSaga");
var ForgotPassword_1 = require("@/pages/forgotPassword/components/ForgotPassword");
var RootForgotPasswordReducer_1 = require("@/pages/forgotPassword/reducers/RootForgotPasswordReducer");
var RootForgotPasswordSaga_1 = require("@/pages/forgotPassword/sagas/RootForgotPasswordSaga");
var ForgotPasswordResult_1 = require("@/pages/forgotPassword/components/ForgotPasswordResult");
var ContactAgent_1 = require("@/pages/contactAgent/components/ContactAgent");
var RootForgotPasswordResultSaga_1 = require("@/pages/forgotPassword/sagas/RootForgotPasswordResultSaga");
var RootForgotPasswordResultReducer_1 = require("@/pages/forgotPassword/reducers/RootForgotPasswordResultReducer");
var RootHomeReducer_1 = require("@/pages/home/reducers/RootHomeReducer");
var RootHomeSaga_1 = require("@/pages/home/sagas/RootHomeSaga");
var HomeZh_1 = require("@/pages/homeZh/components/HomeZh");
var RootHomeZhReducer_1 = require("@/pages/homeZh/reducers/RootHomeZhReducer");
var RootHomeZhSaga_1 = require("@/pages/homeZh/sagas/RootHomeZhSaga");
var Investor_1 = require("@/pages/investor/components/Investor");
var RootInvestorReducer_1 = require("@/pages/investor/reducers/RootInvestorReducer");
var InvestorSaga_1 = require("@/pages/investor/sagas/InvestorSaga");
var ListProperty_1 = require("@/pages/listProperty/components/ListProperty");
var RootListPropertyReducer_1 = require("@/pages/listProperty/reducers/RootListPropertyReducer");
var RootListPropertySaga_1 = require("@/pages/listProperty/sagas/RootListPropertySaga");
var Lockout_1 = require("@/pages/lockout/components/Lockout");
var RootLockoutReducer_1 = require("@/pages/lockout/reducers/RootLockoutReducer");
var RootLockoutSaga_1 = require("@/pages/lockout/sagas/RootLockoutSaga");
var Building_1 = require("@/pages/place/components/Building");
var District_1 = require("@/pages/place/components/District");
var Block_1 = require("@/pages/place/components/Block");
var RootBuildingReducer_1 = require("@/pages/place/reducers/RootBuildingReducer");
var RootDistrictReducer_1 = require("@/pages/place/reducers/RootDistrictReducer");
var RootBlockReducer_1 = require("@/pages/place/reducers/RootBlockReducer");
var BuildingSaga_1 = require("@/pages/place/sagas/BuildingSaga");
var DistrictSaga_1 = require("@/pages/place/sagas/DistrictSaga");
var BlockSaga_1 = require("@/pages/place/sagas/BlockSaga");
var PriceList_1 = require("@/pages/priceList/components/PriceList");
var RootPriceListReducer_1 = require("@/pages/priceList/reducers/RootPriceListReducer");
var PriceListSaga_1 = require("@/pages/priceList/sagas/PriceListSaga");
var ReverifyEmail_1 = require("@/pages/reverifyEmail/components/ReverifyEmail");
var ReverifyEmailResult_1 = require("@/pages/reverifyEmail/components/ReverifyEmailResult");
var RootReverifyEmailReducer_1 = require("@/pages/reverifyEmail/reducers/RootReverifyEmailReducer");
var RootReverifyEmailResultReducer_1 = require("@/pages/reverifyEmail/reducers/RootReverifyEmailResultReducer");
var RootReverifyEmailSaga_1 = require("@/pages/reverifyEmail/sagas/RootReverifyEmailSaga");
var RootReverifyEmailResultSaga_1 = require("@/pages/reverifyEmail/sagas/RootReverifyEmailResultSaga");
var SaveSearchPage_1 = require("@/pages/savesearch/components/SaveSearchPage");
var RootSaveSearchReducer_1 = require("@/pages/savesearch/reducers/RootSaveSearchReducer");
var RootSaveSearchSaga_1 = require("@/pages/savesearch/sagas/RootSaveSearchSaga");
var StaticContent_1 = require("@/pages/staticContent/components/StaticContent");
var RootStaticContentReducer_1 = require("@/pages/staticContent/reducers/RootStaticContentReducer");
var StaticContentSaga_1 = require("@/pages/staticContent/sagas/StaticContentSaga");
var Testimonials_1 = require("@/pages/testimonials/Testimonials");
var reducers_1 = require("@/pages/testimonials/reducers/reducers");
var sagas_1 = require("@/pages/testimonials/sagas/sagas");
var PeopleListing_1 = require("@/pages/peopleListing/components/PeopleListing");
var NewsAndInsights_1 = require("@/pages/newsAndInsights/NewsAndInsights");
var Guides_1 = require("@/pages/guides/Guides");
var InThePress_1 = require("@/pages/inThePress/InThePress");
var Stampduty_1 = require("@/pages/stampduty/components/Stampduty");
var Insights_1 = require("@/pages/insights/Insights");
var Dbguide_1 = require("@/pages/dbguide/components/Dbguide");
var sagas_2 = require("@/pages/articleDetail/sagas/sagas");
var reducers_2 = require("@/pages/articleDetail/reducers/reducers");
var ArticleDetail_1 = require("@/pages/articleDetail/ArticleDetail");
var sagas_3 = require("@/pages/inThePress/sagas/sagas");
var reducers_3 = require("@/pages/inThePress/reducers/reducers");
var reducers_4 = require("@/pages/newsAndInsights/reducers/reducers");
var sagas_4 = require("@/pages/newsAndInsights/sagas/sagas");
var reducers_5 = require("@/pages/guides/reducers/reducers");
var sagas_5 = require("@/pages/guides/sagas/sagas");
var RootStampdutySaga_1 = require("@/pages/stampduty/sagas/RootStampdutySaga");
var RootStampdutyReducer_1 = require("@/pages/stampduty/reducers/RootStampdutyReducer");
var reducers_6 = require("@/pages/insights/reducers/reducers");
var sagas_6 = require("@/pages/insights/sagas/sagas");
var RootDbGuideReducer_1 = require("@/pages/dbguide/reducers/RootDbGuideReducer");
var RootDbGuideSaga_1 = require("@/pages/dbguide/sagas/RootDbGuideSaga");
var executiveListingSaga_1 = require("@/pages/peopleListing/sagas/executiveListingSaga");
var agentListingSaga_1 = require("@/pages/peopleListing/sagas/agentListingSaga");
var executiveListingReducer_1 = require("@/pages/peopleListing/reducers/executiveListingReducer");
var agentListingReducer_1 = require("@/pages/peopleListing/reducers/agentListingReducer");
var Detail_1 = require("@/pages/detail/components/Detail");
var RootDetailReducer_1 = require("@/pages/detail/reducers/RootDetailReducer");
var RootDetailSaga_1 = require("@/pages/detail/sagas/RootDetailSaga");
var RootAskAnAgentListSaga_1 = require("@/pages/askAnAgentList/sagas/RootAskAnAgentListSaga");
var AskAnAgentList_1 = require("@/pages/askAnAgentList/components/AskAnAgentList");
var RootAskAnAgentListReducer_1 = require("@/pages/askAnAgentList/reducers/RootAskAnAgentListReducer");
var DetailAmp_1 = require("@/pages/detail/components/DetailAmp");
var ArticleDetailAmp_1 = require("@/pages/articleDetail/ArticleDetailAmp");
var NotFound_1 = require("@/pages/notFound/components/NotFound");
var RootNotFoundReducer_1 = require("@/pages/notFound/reducers/RootNotFoundReducer");
var DetailNotFound_1 = require("@/pages/detail/components/DetailNotFound");
var RootDetailNotFoundReducer_1 = require("@/pages/detail/reducers/RootDetailNotFoundReducer");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var AskAnAgent_1 = require("@/pages/askAnAgent/components/AskAnAgent");
var RootAskAnAgentReducer_1 = require("@/pages/askAnAgent/reducers/RootAskAnAgentReducer");
var RootAskAnAgentSaga_1 = require("@/pages/askAnAgent/sagas/RootAskAnAgentSaga");
var Sitemap_1 = require("@/pages/sitemap/components/Sitemap");
var RootSitemapReducer_1 = require("@/pages/sitemap/reducers/RootSitemapReducer");
var SitemapSaga_1 = require("@/pages/sitemap/sagas/SitemapSaga");
var callAllSaga_1 = require("@/rendering/common/callAllSaga");
var Estate_1 = require("@/pages/estate/components/Estate");
var RootEstateReducer_1 = require("@/pages/estate/reducers/RootEstateReducer");
var RootEstateSaga_1 = require("@/pages/estate/sagas/RootEstateSaga");
var RootMortgageMonthlyReducer_1 = require("@/pages/mortagage/reducers/RootMortgageMonthlyReducer");
var MortgageMonthly_1 = require("@/pages/mortagage/components/MortgageMonthly");
var RootMortgageSaga_1 = require("@/pages/mortagage/sagas/RootMortgageSaga");
var Affordability_1 = require("@/pages/mortagage/components/Affordability");
var RootAffordabilityReducer_1 = require("@/pages/mortagage/reducers/RootAffordabilityReducer");
var Refinance_1 = require("@/pages/mortagage/components/Refinance");
var RootRefinanceReducer_1 = require("@/pages/mortagage/reducers/RootRefinanceReducer");
var RootAffordabilityByPaymentReducer_1 = require("@/pages/mortagage/reducers/RootAffordabilityByPaymentReducer");
var SaveProperties_1 = require("@/pages/saveproperties/components/SaveProperties");
var RootSavePropertiesReducer_1 = require("@/pages/saveproperties/reducers/RootSavePropertiesReducer");
var RootRecentlyViewedReducer_1 = require("@/pages/saveproperties/reducers/RootRecentlyViewedReducer");
var RootSavePropertiesSaga_1 = require("@/pages/saveproperties/sagas/RootSavePropertiesSaga");
var RootRecentlyViewedSaga_1 = require("@/pages/saveproperties/sagas/RootRecentlyViewedSaga");
var Faq_1 = require("@/pages/faq/components/Faq");
var RootFaqSaga_1 = require("@/pages/faq/sagas/RootFaqSaga");
var RootFaqReducer_1 = require("@/pages/faq/reducers/RootFaqReducer");
var Unsubscribe_1 = require("@/pages/unsubscribe/components/Unsubscribe");
var PropertyTransaction_1 = require("@/pages/transaction/components/PropertyTransaction");
var RootUnsubscribeSaga_1 = require("@/pages/unsubscribe/sagas/RootUnsubscribeSaga");
var RootUnsubscribeReducer_1 = require("@/pages/unsubscribe/reducers/RootUnsubscribeReducer");
var DetailNotFoundAmp_1 = require("@/pages/detail/components/DetailNotFoundAmp");
var Exclusive_1 = require("@/pages/exclusive/components/Exclusive");
var ExclusiveSaga_1 = require("@/pages/exclusive/sagas/ExclusiveSaga");
var RootExclusiveReducer_1 = require("@/pages/exclusive/reducers/RootExclusiveReducer");
var RootPropertyTransactionReducer_1 = require("@/pages/transaction/reducers/RootPropertyTransactionReducer");
var PendingDocument_1 = require("@/pages/document/components/PendingDocument");
var RootDocumentSaga_1 = require("@/pages/document/sagas/RootDocumentSaga");
var RootPendingDocumentReducer_1 = require("@/pages/document/reducers/RootPendingDocumentReducer");
var RootSignedDocumentReducer_1 = require("@/pages/document/reducers/RootSignedDocumentReducer");
var SignedDocument_1 = require("@/pages/document/components/SignedDocument");
var MyListing_1 = require("@/pages/myproperty/components/MyListing");
var RootMyListingReducer_1 = require("@/pages/myproperty/reducers/RootMyListingReducer");
var RootMyViewingReducer_1 = require("@/pages/myproperty/reducers/RootMyViewingReducer");
var RootMyPropertySaga_1 = require("@/pages/myproperty/sagas/RootMyPropertySaga");
var MyViewing_1 = require("@/pages/myproperty/components/MyViewing");
exports.pageMap = (_a = {},
    _a[Pages_1.Pages.HOME] = {
        view: Home_1.default,
        reducer: RootHomeReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootHomeSaga_1.rootHomeSagas),
        name: 'home',
    },
    _a[Pages_1.Pages.HOME_ZH] = {
        view: HomeZh_1.default,
        reducer: RootHomeZhReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootHomeZhSaga_1.rootHomeZhSagas),
        name: 'homeZh',
    },
    _a[Pages_1.Pages.SEARCH] = {
        view: Search_1.default,
        reducer: RootSearchReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootSearchSaga_1.rootSearchSagas),
        name: 'searchPage',
    },
    _a[Pages_1.Pages.SAVE_SEARCH] = {
        view: SaveSearchPage_1.default,
        reducer: RootSaveSearchReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootSaveSearchSaga_1.rootSaveSearchSagas),
        name: 'saveSearch',
    },
    _a[Pages_1.Pages.DEVELOPMENTS] = {
        view: Developments_1.default,
        reducer: RootDevelopmentsReducer_1.default,
        saga: callAllSaga_1.callAllSaga(DevelopmentsSaga_1.rootDevelopmentsSagas),
        name: 'developments',
    },
    _a[Pages_1.Pages.DEVELOPMENT] = {
        view: Development_1.default,
        reducer: RootDevelopmentReducer_1.default,
        saga: callAllSaga_1.callAllSaga(DevelopmentSaga_1.rootDevelopmentSagas),
        name: 'development',
    },
    _a[Pages_1.Pages.ALERT] = {
        view: Alert_1.default,
        reducer: RootAlertReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootAlertSaga_1.rootAlertSagas),
        name: 'alert',
    },
    _a[Pages_1.Pages.ACCOUNT_INFO] = {
        view: AccountInfo_1.default,
        reducer: RootAccountInfoReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootAccountInfoSaga_1.rootAccountInfoSagas),
        name: 'accountInfo',
    },
    _a[Pages_1.Pages.CONFIRM_EMAIL_REGISTER] = {
        view: ConfirmEmailRegister_1.default,
        reducer: RootConfirmEmailRegisterReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootConfirmEmailRegisterSaga_1.rootConfirmEmailRegisterSagas),
        name: 'confirmEmailRegister',
    },
    _a[Pages_1.Pages.LOCKOUT] = {
        view: Lockout_1.default,
        reducer: RootLockoutReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootLockoutSaga_1.rootLockoutSagas),
        name: 'lockout',
    },
    _a[Pages_1.Pages.FORGOT_PASSWORD] = {
        view: ForgotPassword_1.default,
        reducer: RootForgotPasswordReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootForgotPasswordSaga_1.rootForgotPasswordSagas),
        name: 'forgotPassword',
    },
    _a[Pages_1.Pages.FORGOT_PASSWORD_RESULT] = {
        view: ForgotPasswordResult_1.default,
        reducer: RootForgotPasswordResultReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootForgotPasswordResultSaga_1.rootForgotPasswordResultSagas),
        name: 'forgotPasswordResult',
    },
    _a[Pages_1.Pages.REVERIFY_EMAIL] = {
        view: ReverifyEmail_1.default,
        reducer: RootReverifyEmailReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootReverifyEmailSaga_1.rootReverifyEmailSagas),
        name: 'reverifyEmail',
    },
    _a[Pages_1.Pages.REVERIFY_EMAIL_RESULT] = {
        view: ReverifyEmailResult_1.default,
        reducer: RootReverifyEmailResultReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootReverifyEmailResultSaga_1.rootReverifyEmailResultSagas),
        name: 'reverifyEmailResult',
    },
    _a[Pages_1.Pages.CONTACT_AGENT] = {
        view: ContactAgent_1.default,
        reducer: RootContactAgentReducer_1.default,
        saga: callAllSaga_1.callAllSaga(ContactAgentPageSaga_1.rootContactAgentPageSagas),
        name: 'contactAgent',
    },
    _a[Pages_1.Pages.STATIC_CONTENT] = {
        view: StaticContent_1.default,
        reducer: RootStaticContentReducer_1.default,
        saga: callAllSaga_1.callAllSaga(StaticContentSaga_1.rootStaticContentSagas),
        name: 'staticContent',
    },
    _a[Pages_1.Pages.INVESTOR] = {
        view: Investor_1.default,
        reducer: RootInvestorReducer_1.default,
        saga: callAllSaga_1.callAllSaga(InvestorSaga_1.rootInvestorSaga),
        name: 'investor',
    },
    _a[Pages_1.Pages.ABOUTUS] = {
        view: AboutUs_1.default,
        reducer: RootAboutUsReducer_1.default,
        saga: callAllSaga_1.callAllSaga(AboutUsSaga_1.rootAboutUsSagas),
        name: 'aboutUs',
    },
    _a[Pages_1.Pages.PRICE_LIST] = {
        view: PriceList_1.default,
        reducer: RootPriceListReducer_1.default,
        saga: callAllSaga_1.callAllSaga(PriceListSaga_1.rootPriceListSagas),
        name: 'priceList',
    },
    _a[Pages_1.Pages.ACCOUNT_LOGIN] = {
        view: AccountLogin_1.default,
        reducer: RootAccountLoginReducer_1.default,
        saga: callAllSaga_1.callAllSaga(AccountLoginSaga_1.rootAccountLoginSagas),
        name: 'accountLogin',
    },
    _a[Pages_1.Pages.BUILDING] = {
        view: Building_1.default,
        reducer: RootBuildingReducer_1.default,
        saga: callAllSaga_1.callAllSaga(BuildingSaga_1.rootBuildingSagas),
        name: 'building',
    },
    _a[Pages_1.Pages.DISTRICT] = {
        view: District_1.default,
        reducer: RootDistrictReducer_1.default,
        saga: callAllSaga_1.callAllSaga(DistrictSaga_1.rootDistrictSagas),
        name: 'district',
    },
    _a[Pages_1.Pages.LIST_PROPERTY] = {
        view: ListProperty_1.default,
        reducer: RootListPropertyReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootListPropertySaga_1.rootListPropertySagas),
        name: 'listProperty',
    },
    _a[Pages_1.Pages.AGENT_PROFILE] = {
        view: AgentProfile_1.default,
        reducer: RootAgentProfileReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootAgentProfileSaga_1.rootAgentProfileSagas),
        name: 'agentProfile',
    },
    _a[Pages_1.Pages.AGENT_LISTING] = {
        view: PeopleListing_1.default,
        reducer: agentListingReducer_1.default,
        saga: callAllSaga_1.callAllSaga(agentListingSaga_1.rootAgentListingSagas),
        name: 'agentListing',
    },
    _a[Pages_1.Pages.TESTIMONIALS] = {
        view: Testimonials_1.default,
        reducer: reducers_1.default,
        saga: callAllSaga_1.callAllSaga(sagas_1.rootTestimonialsSagas),
        name: 'testimonials',
    },
    _a[Pages_1.Pages.NEWS_AND_INSIGHTS] = {
        view: NewsAndInsights_1.default,
        reducer: reducers_4.default,
        saga: callAllSaga_1.callAllSaga(sagas_4.rootNewsAndInsightsSagas),
        name: 'newsAndInsights',
    },
    _a[Pages_1.Pages.GUIDES] = {
        view: Guides_1.default,
        reducer: reducers_5.default,
        saga: callAllSaga_1.callAllSaga(sagas_5.rootGuidesSagas),
        name: 'guides',
    },
    _a[Pages_1.Pages.IN_THE_PRESS] = {
        view: InThePress_1.default,
        reducer: reducers_3.default,
        saga: callAllSaga_1.callAllSaga(sagas_3.rootInThePressSagas),
        name: 'inThePress',
    },
    _a[Pages_1.Pages.STAMP_DUTY] = {
        view: Stampduty_1.default,
        reducer: RootStampdutyReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootStampdutySaga_1.rootStampdutySagas),
        name: 'stampduty',
    },
    _a[Pages_1.Pages.INSIGHTS] = {
        view: Insights_1.default,
        reducer: reducers_6.default,
        saga: callAllSaga_1.callAllSaga(sagas_6.rootInsightsSagas),
        name: 'insights',
    },
    _a[Pages_1.Pages.EXECUTIVE_LISTING] = {
        view: PeopleListing_1.default,
        reducer: executiveListingReducer_1.default,
        saga: callAllSaga_1.callAllSaga(executiveListingSaga_1.rootExecutiveListingSagas),
        name: 'executiveListing',
    },
    _a[Pages_1.Pages.NEWS_AND_INSIGHTS_DETAIL] = {
        view: ArticleDetail_1.default,
        reducer: reducers_2.default,
        saga: callAllSaga_1.callAllSaga(sagas_2.rootArticleDetailSagas),
        name: 'articleDetails',
    },
    _a[Pages_1.Pages.NEWS_AND_INSIGHTS_DETAIL_AMP] = {
        view: ArticleDetailAmp_1.default,
        reducer: reducers_2.rootArticleDetailAmpReducer,
        saga: null,
        name: 'articleDetailsAmp',
        scripts: [
            'amp-lightbox',
            'amp-bind',
            'amp-form',
            'amp-user-notification',
            'amp-sidebar',
            'amp-video',
            'amp-instagram',
        ],
    },
    _a[Pages_1.Pages.DISCOVERY_BAY_GUIDE] = {
        view: Dbguide_1.default,
        reducer: RootDbGuideReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootDbGuideSaga_1.rootDbGuideSagas),
        name: 'discoveryBayGuide',
    },
    _a[Pages_1.Pages.PROPERTY_DETAIL] = {
        view: Detail_1.default,
        reducer: RootDetailReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootDetailSaga_1.rootDetailSagas),
        name: 'detail',
    },
    _a[Pages_1.Pages.ASK_AN_AGENT_LIST] = {
        view: AskAnAgentList_1.default,
        reducer: RootAskAnAgentListReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootAskAnAgentListSaga_1.rootAskAnAgentListSagas),
        name: 'askAnAgentList',
    },
    _a[Pages_1.Pages.PROPERTY_DETAIL_AMP] = {
        view: DetailAmp_1.default,
        reducer: RootDetailReducer_1.rootDetailAmpReducer,
        saga: null,
        name: 'detailAmp',
        scripts: [
            'amp-lightbox',
            'amp-bind',
            'amp-lightbox-gallery',
            'amp-carousel',
            'amp-form',
            'amp-user-notification',
            'amp-sidebar',
        ],
    },
    _a[Pages_1.Pages.DETAIL_NOT_FOUND_AMP] = {
        view: DetailNotFoundAmp_1.default,
        reducer: RootDetailNotFoundReducer_1.rootDetailNotFoundAmpReducer,
        saga: null,
        name: 'detailNotFoundAmp',
        scripts: [
            'amp-lightbox',
            'amp-bind',
            'amp-lightbox-gallery',
            'amp-carousel',
            'amp-form',
            'amp-user-notification',
            'amp-sidebar',
        ],
    },
    _a[Pages_1.Pages.NOT_FOUND] = {
        view: NotFound_1.default,
        reducer: RootNotFoundReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootPublicPageSaga_1.rootPublicPageSagas),
        name: 'notFound',
    },
    _a[Pages_1.Pages.DETAIL_NOT_FOUND] = {
        view: DetailNotFound_1.default,
        reducer: RootDetailNotFoundReducer_1.rootDetailNotFoundReducer,
        saga: callAllSaga_1.callAllSaga(RootDetailSaga_1.rootDetailSagas),
        name: 'detailNotFound',
    },
    _a[Pages_1.Pages.ASK_AN_AGENT] = {
        view: AskAnAgent_1.default,
        reducer: RootAskAnAgentReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootAskAnAgentSaga_1.rootAskAnAgentSagas),
        name: 'askAnAgent',
    },
    _a[Pages_1.Pages.SITEMAP] = {
        view: Sitemap_1.default,
        reducer: RootSitemapReducer_1.default,
        saga: callAllSaga_1.callAllSaga(SitemapSaga_1.rootSitemapSagas),
        name: 'sitemap',
    },
    _a[Pages_1.Pages.ESTATE] = {
        view: Estate_1.default,
        reducer: RootEstateReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootEstateSaga_1.rootEstateSagas),
        name: 'estate',
    },
    _a[Pages_1.Pages.MORTGAGE_REPAYMENT] = {
        view: MortgageMonthly_1.default,
        reducer: RootMortgageMonthlyReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootMortgageSaga_1.rootMortgageSagas),
        name: 'mortgagePayment',
    },
    _a[Pages_1.Pages.MORTGAGE_AFFORDABLILTY] = {
        view: Affordability_1.default,
        reducer: RootAffordabilityReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootMortgageSaga_1.rootMortgageSagas),
        name: 'affordability',
    },
    _a[Pages_1.Pages.MORTGAGE_REFINANCE] = {
        view: Refinance_1.default,
        reducer: RootRefinanceReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootMortgageSaga_1.rootMortgageSagas),
        name: 'refinance',
    },
    _a[Pages_1.Pages.MORTGAGE_AFFORDABLILTY_BY_PAYMENT] = {
        view: Affordability_1.default,
        reducer: RootAffordabilityByPaymentReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootMortgageSaga_1.rootMortgageSagas),
        name: 'affordabilityByPayment',
    },
    _a[Pages_1.Pages.SAVE_PROPERTIES] = {
        view: SaveProperties_1.default,
        reducer: RootSavePropertiesReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootSavePropertiesSaga_1.rootSavePropertiesSagas),
        name: 'saveProperties',
    },
    _a[Pages_1.Pages.RECENTLY_VIEWED] = {
        view: SaveProperties_1.default,
        reducer: RootRecentlyViewedReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootRecentlyViewedSaga_1.rootRecentlyViewedSagas),
        name: 'recentlyViewed',
    },
    _a[Pages_1.Pages.FAQ] = {
        view: Faq_1.default,
        reducer: RootFaqReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootFaqSaga_1.rootFaqSagas),
        name: 'faq',
    },
    _a[Pages_1.Pages.UNSUBSCRIBE] = {
        view: Unsubscribe_1.default,
        reducer: RootUnsubscribeReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootUnsubscribeSaga_1.rootUnsubscribeSagas),
        name: 'unsubscribe',
    },
    _a[Pages_1.Pages.BLOCK] = {
        view: Block_1.default,
        reducer: RootBlockReducer_1.default,
        saga: callAllSaga_1.callAllSaga(BlockSaga_1.rootBlockSagas),
        name: 'block',
    },
    _a[Pages_1.Pages.EXCLUSIVE] = {
        view: Exclusive_1.default,
        reducer: RootExclusiveReducer_1.default,
        saga: callAllSaga_1.callAllSaga(ExclusiveSaga_1.rootExclusiveSagas),
        name: 'exclusive',
    },
    _a[Pages_1.Pages.PROPERTY_TRANSACTION] = {
        view: PropertyTransaction_1.default,
        reducer: RootPropertyTransactionReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootDetailSaga_1.rootDetailSagas),
        name: 'propertyTransaction',
    },
    _a[Pages_1.Pages.PENDING_DOCUMENT] = {
        view: PendingDocument_1.default,
        reducer: RootPendingDocumentReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootDocumentSaga_1.rootDocumentSagas),
        name: 'pendingDocument',
    },
    _a[Pages_1.Pages.SIGNED_DOCUMENT] = {
        view: SignedDocument_1.default,
        reducer: RootSignedDocumentReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootDocumentSaga_1.rootDocumentSagas),
        name: 'pendingDocument',
    },
    _a[Pages_1.Pages.MY_LISTINGS] = {
        view: MyListing_1.default,
        reducer: RootMyListingReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootMyPropertySaga_1.rootMyPropertySagas),
        name: 'myListing',
    },
    _a[Pages_1.Pages.MY_VIEWINGS] = {
        view: MyViewing_1.default,
        reducer: RootMyViewingReducer_1.default,
        saga: callAllSaga_1.callAllSaga(RootMyPropertySaga_1.rootMyPropertySagas),
        name: 'myViewing',
    },
    _a);
